export default {
  init() {
    // JavaScript to be fired on the settings page
    // save alert info
    $('#daPhone').change(function() {
      $('#daSelPhone').prop('checked', $('#daPhone').val().trim().length > 0);
      $('#daPhone').val($('#daPhone').val().trim());
    });
    $('#daEmail').change(function() {
      $('#daSelEmail').prop('checked', $('#daEmail').val().trim().length > 0);
      $('#daEmail').val($('#daEmail').val().trim());
    });
    $('#daSMS').change(function() {
      $('#daSelSMS').prop('checked', $('#daSMS').val().trim().length > 0);
      $('#daSMS').val($('#daSMS').val().trim());
    });
    $('#daSelPhone').change(function() {
      if ($('#daSelPhone').prop('checked') == false) {
        $('#daPhone').val('');
      }
    });
    $('#daSelEmail').change(function() {
      if ($('#daSelEmail').prop('checked') == false) {
        $('#daEmail').val('');
      }
    });
    $('#daSelSMS').change(function() {
      if ($('#daSelSMS').prop('checked') == false) {
        $('#daSMS').val('');
      }
    });

    $('#rtEmail').change(function() {
      $('#rtSelEmail').prop('checked', $('#rtEmail').val().trim().length > 0);
      $('#rtEmail').val($('#rtEmail').val().trim());
    });
    $('#rtSMS').change(function() {
      $('#rtSelSMS').prop('checked', $('#rtSMS').val().trim().length > 0);
      $('#rtSMS').val($('#rtSMS').val().trim());
    });
    $('#rtSelEmail').change(function() {
      if ($('#rtSelEmail').prop('checked') == false) {
        $('#rtEmail').val('');
      }
    });
    $('#rtSelSMS').change(function() {
      if ($('#rtSelMS').prop('checked') == false) {
        $('#rtSMS').val('');
      }
    });

    $('#alerts-form').submit(function(e) {
      e.preventDefault();
      $('#accountAlerts').val($('#account').val());

      // Polish the data for HPA handling
      $('#alerts-container #rtEmail').val($('#alerts-container #daEmail').val());
      $('#alerts-container #rtSMS').val($('#alerts-container #daSMS').val());

      // trigger events to uncheck boxes
      $('#daPhone').trigger('change');
      $('#daEmail').trigger('change');
      $('#daSMS').trigger('change');

      // set a 0 explicitly in order to guarantee pass to back end
      //console.log($('#daSelPhone').prop('checked'));
      if ($('#daSelPhone').prop('checked') == false) {
        $('#daSelPhone').val('0');
      }
      if ($('#daSelEmail').prop('checked') == false) {
        $('#daSelEmail').val('0');
      }
      if ($('#daSelSMS').prop('checked') == false) {
        $('#daSelSMS').val('0');
      }

      $.post( '/rrtpbillcompare/Servlet?activity=alerts-form-submit', $('#alerts-form').serialize()).done(function( data ) {
        alert('Hourly Pricing Alert settings saved')
      });

      false;
    });

    // save load guard info
    $('#load-guard-form-submit').click(function() {
      $('#accountLoadGuard').val($('#account').val());
      $('#loadGuardStatus').val($('#alerts-container .enrollmentStatus').html());
      $.post( '/rrtpbillcompare/Servlet?activity=load-guard-form-submit', $('#load-guard-form').serialize())
      .done(function( data ) {
        // clear the settings
        $('#lgDeactivate').prop('checked', false);
        $('#lgActivate').prop('checked', false);
        alert('Load Guard Settings saved.');
        window.location.reload();
      });
    });

    // toggle load guard selections
    $('#lgActivate').click(function() {
      $('#lgDeactivate').prop('checked', false);
    });
    $('#lgDeactivate').click(function() {
      $('#lgActivate').prop('checked', false);
    });

    // cancel
    $('#form-cancel').click(function() {
      location.reload();
    });

    function formAction() {
      //document.newForm.action = '/rrtpbillcompare/Servlet?activity=alerts-form-submit&accountAlerts=' + $('#account').val();
    }

    // make global, since webpack uses enclosures to scope partials
    window.mhpa = window.mhpa || {};
    window.mhpa.loadAccountData = function() {

      // set user account
      //$('#alerts-form').attr('action', '/rrtpbillcompare/Servlet?activity=alerts-form-submit&accountAlerts=' + $('#account').val());
      // load user data
      $.getJSON('/rrtpbillcompare/Servlet?type=alerts-container&account=' + $('#account').val(), function(json) {
        //console.log(json); //Veracode #631 - best to hide code
        $('#alerts-container #rtSel10').prop('checked', json.rtSel10 == '1');
        $('#alerts-container #rtSel14').prop('checked', json.rtSel14 == '1');
        $('#alerts-container #rtSelEmail').prop('checked', json.rtSelEmail == '1');
        $('#alerts-container #rtSelSMS').prop('checked', json.rtSelSMS == '1');
        $('#alerts-container #rtEmail').val(json.rtEmail);
        $('#alerts-container #rtSMS').val(json.rtSMS);
        $('#alerts-container #daSelPhone').prop('checked', json.daSelPhone == '1');
        $('#alerts-container #daSelEmail').prop('checked', json.daSelEmail == '1');
        $('#alerts-container #daSelSMS').prop('checked', json.daSelSMS == '1');
        $('#alerts-container #daPhone').val(json.daPhone);
        $('#alerts-container #daEmail').val(json.daEmail);
        $('#alerts-container #daSMS').val(json.daSMS);
        // Polish the data for HPA handling
        if ($('#alerts-container #daEmail').val().trim() == '' && json.rtEmail.trim() != '') {
          $('#alerts-container #daEmail').val(json.rtEmail.trim());
        }
        if ($('#alerts-container #daSMS').val().trim() == '' && json.rtSMS.trim() != '') {
          $('#alerts-container #daSMS').val(json.rtSMS.trim());
        }
        // Status
        //$('#lg-status').attr('src', '/wp-content/themes/rrtp/resources/old-theme/img/Status-INACTIVE.png');
        $('#lg-status').addClass('inactive').text('Inactive');
       // $('#lg-status').attr('alt', 'Unenrolled.');
        if (json.lgStatus != '') {
          //$('#lg-status').attr('src', '/wp-content/themes/rrtp/resources/old-theme/img/Status-' + json.lgStatus.toUpperCase() + '.png');
          //$('#lg-status').addClass('enrolled').text('Enrolled');
          //$('#lg-status').addClass('enrolled').text(json.lgStatus);
          //$('#lg-status').attr('alt', 'Enrolled.');
          var displayLGStatus = 'Inactive';
          if(json.lgStatus == 'Enroll'){
            displayLGStatus = 'Pending Enroll';
          }else if(json.lgStatus == 'Pending Enrollment'){
            displayLGStatus = 'Pending Enroll';
         }else if(json.lgStatus == 'Pending AC Cycling'){
            displayLGStatus = 'Inactive';
         }else if(json.lgStatus == 'Pending Device Installation'){
            displayLGStatus = 'Pending Enroll';
         }else if(json.lgStatus == 'Enrolled'){
            displayLGStatus = 'Enrolled';
         }else if(json.lgStatus == 'Setpoint Change Request'){
            displayLGStatus = 'Inactive';
         }else if(json.lgStatus == 'Withdraw'){
            displayLGStatus = 'Pending Inactive';
         }else if(json.lgStatus == 'Withdrawn'){
            displayLGStatus = 'Inactive';
         }else if(json.lgStatus == 'Cancelled'){
            displayLGStatus = 'Inactive';
         } 
         $('#lg-status').addClass('enrolled').text(displayLGStatus);
        }
        if (json.lgStatus.toLowerCase() == 'enrolled') {
          $('#lgActivate').prop('checked', false);
          $('#lgDeactivate').prop('checked', false);
          /*
          ind = 0;
          if (json.lgLevel == '10')
            ind = 0;
          else if (json.lgLevel == '14')
            ind = 1;
          $('#alerts-container #lgLevel')[ind].checked = true;
          */
        } else {
          //$('#alerts-container #lgLevel').prop('checked', false);
          $('#lgActivate').prop('checked', false);
          $('#lgDeactivate').prop('checked', false);
        }
      });
    };

    mhpa.loadAccountData();

  },
  finalize() {
    // JavaScript to be fired on the settings page, after the init JS
  },
};
